const MATCHING_RESULTS_SORT_OPTIONS = ['distance', 'total', 'pricePerTon', 'name'] as const
export type MatchingResultsSortOption = (typeof MATCHING_RESULTS_SORT_OPTIONS)[number]

class SortState {
	sortDirection: 'asc' | 'desc' = $state('asc')
	sortBy: MatchingResultsSortOption = $state('total')
	searchTerm: string | undefined = $state()
  showTopMatches: boolean = $state(true);
}

export const sortState = new SortState()
